import React from 'react'

function Article1(props) {
  return (
    <article>
  <h3>Vowels</h3>
  <p>Arabic only has three vowels: a: ا, i: ي and u: و.</p>
  <p>Note that ي is also used for the semi-consonant y and و is used for w. </p>
  <p>Thus the word "water" would be written using "و". </p>
  <p>In Arabic, letters bind to each other just like the latin alphabet when written cursively.</p>
  <p>In initial position, only ي binds to the following letter. </p>
  <p>Thus, ياد would be read as "yad". </p>
    </article>
  )
}

export default Article1
